module.exports = __webpack_public_path__ + "img/custom_logo.45104a50.svg";